import {
  RECORD_STATUS_ACTIVE,
  RECORD_STATUS_BLOCKED,
  RECORD_STATUS_CONFIRAMTION_PENDING,
  RECORD_STATUS_DEDUPLICATED,
  RECORD_STATUS_LOCAL,
  RECORD_STATUS_NEW,
  RECORD_STATUS_NOT_CHECKED,
  RECORD_STATUS_PARTIALLY_REVIEWED,
  RECORD_STATUS_REMOVED,
  RECORD_STATUS_REVIEWED,
  RECORD_STATUS_TO_BE_REMOVED,
} from './record-status.constants';

export type DrugStatusId =
  | typeof RECORD_STATUS_REMOVED
  | typeof RECORD_STATUS_DEDUPLICATED
  | typeof RECORD_STATUS_BLOCKED
  | typeof RECORD_STATUS_NEW
  | typeof RECORD_STATUS_LOCAL
  | typeof RECORD_STATUS_NOT_CHECKED
  | typeof RECORD_STATUS_ACTIVE
  | typeof RECORD_STATUS_PARTIALLY_REVIEWED
  | typeof RECORD_STATUS_REVIEWED
  | typeof RECORD_STATUS_TO_BE_REMOVED;

export const DrugStatusIds = [
  RECORD_STATUS_NEW,
  RECORD_STATUS_LOCAL,
  RECORD_STATUS_REMOVED,
  RECORD_STATUS_DEDUPLICATED,
  RECORD_STATUS_BLOCKED,
  RECORD_STATUS_NOT_CHECKED,
  RECORD_STATUS_ACTIVE,
  RECORD_STATUS_PARTIALLY_REVIEWED,
  RECORD_STATUS_REVIEWED,
  RECORD_STATUS_TO_BE_REMOVED,
] as const;

export const NamesByDrugStatusId = {
  [RECORD_STATUS_REMOVED]: 'Удалена',
  [RECORD_STATUS_DEDUPLICATED]: 'Дедуплицирована',
  [RECORD_STATUS_BLOCKED]: 'Заблокирована',
  [RECORD_STATUS_NEW]: 'Новая',
  [RECORD_STATUS_LOCAL]: 'Локальная',
  [RECORD_STATUS_NOT_CHECKED]: 'Не проверен',
  [RECORD_STATUS_ACTIVE]: 'Активна',
  [RECORD_STATUS_PARTIALLY_REVIEWED]: 'Частично проверена',
  [RECORD_STATUS_REVIEWED]: 'Проверена',
  [RECORD_STATUS_TO_BE_REMOVED]: 'На удаление',
  [RECORD_STATUS_CONFIRAMTION_PENDING]: 'Ожидает подтверждения',
} as const;
